module.exports = __webpack_public_path__ + "img/bg-section-08-mobile.fd37a2ea.svg";